module.exports = __webpack_public_path__ + "img/placeholder/section-text-img.jpg";